import type {Electricity} from '@domain/electricity'
import {Moment} from 'moment-timezone'

export const isStartOfDay = (datetime: Moment) => datetime.isSame(datetime.clone().startOf('day'))

export const getSubmitTimeFrame = (
  upForPurchasing?: Electricity['upForPurchasing']
): [submitStart: Moment | undefined, submitEnd: Moment | undefined] => {
  if (!upForPurchasing?.length) {
    return [undefined, undefined]
  }

  const start = upForPurchasing[0].dateTimeUTC
  const end = upForPurchasing[upForPurchasing.length - 1].dateTimeUTC
  return [start, end]
}
